<div class="official-website-footer sm:!hidden mx:flex">
  <!-- <span class="contact-label"></span> -->

  <span *ngFor="let link of contactLinks" class="contact-link">
    <a
      [href]="link.url"
      target="_blank"
      [class.notFirstChild]="!link.firstChild"
    >
      {{ link.text }}
      <svg-icon
        [iconName]="'official-website/externallink.svg'"
        [size]="20"
      ></svg-icon>
      <!-- <img src="assets/official-website/externallink.svg" alt="export" style="width: 1.2em"> -->
    </a>
  </span>
</div>
<div class="app-footer sm:px-0">
  <ul class="app-footer__terms sm:block mx:flex py-5">
    <li class="terms-item">{{ "COMPANY_NAME_DETAIL_FOOTER" | translate }}</li>
    <li class="terms-item">
      <a
        target="_blank"
        href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action"
        >沪ICP备2020030684号-2</a
      >
    </li>
    <li class="terms-item">
      <a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch"
        >沪公网安备31010502007521号</a
      >
    </li>
    <li class="terms-item" (click)="handleViewPrivacy('/myAccount/user-terms')">
      {{ "PRIVACY_TERMS_OF_USE" | translate }}
    </li>
    <li
      class="terms-item"
      (click)="handleViewPrivacy('/myAccount/data-protection-policy', 0)"
    >
      {{ "CORPORATE" | translate }}
    </li>
    <li
      class="terms-item"
      (click)="handleViewPrivacy('/myAccount/data-protection-policy', 1)"
    >
      {{ "Data_PROTECTION_POLICY" | translate }}
    </li>
    <li
      class="terms-item"
      aria-label="Privacy settings"
      (click)="showDockPrivacySettings()"
    >
      {{ "PRIVACY_SETTINGS" | translate }}
    </li>
    <!-- <li class="terms-item" (click)="handleViewPrivacy('/myAccount/data-protection-policy', 1)">{{ "PRIVACY_STATEMENT" | translate }}</li> -->
  </ul>
</div>
